import { createSlice } from "@reduxjs/toolkit";
import {
  fetchParticipants,
  addParticipant,
  updateParticipant,
} from "./tournamentParticipants.thunk";

const initialState = {
  participants: [],
  meta: {
    total: 0,
    total_pages: 1,
    page: 1,
    limit: 10,
  },
  loading: false,
  error: null,
  selectedParticipant: null,
};

const tournamentParticipantsSlice = createSlice({
  name: "tournamentParticipants",
  initialState,

  reducers: {
    setSelectedParticipant: (state, action) => {
      state.selectedParticipant = action.payload;
    },
    clearSelectedParticipant: (state) => {
      state.selectedParticipant = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ================= FETCH ================= */
      .addCase(fetchParticipants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchParticipants.fulfilled, (state, action) => {
        state.loading = false;

        console.log("🔥 FINAL PAYLOAD:", action.payload);

        const payload = action.payload;

        /**
         * 🔥 HANDLE ALL CASES SAFELY
         * Case 1: { data: [...] }
         * Case 2: { data: { data: [...] } }
         * Case 3: undefined
         */
        let participants = [];

        if (Array.isArray(payload?.data)) {
          participants = payload.data;
        } else if (Array.isArray(payload?.data?.data)) {
          participants = payload.data.data;
        }

        state.participants = participants;

        // Safe meta fallback
        state.meta = payload?.meta || {
          total: participants.length,
          total_pages: 1,
          page: 1,
          limit: 10,
        };
      })

      .addCase(fetchParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch participants";
      })

      /* ================= ADD ================= */
      .addCase(addParticipant.fulfilled, (state) => {
        // 🔥 Do nothing → refetch handled in component
        state.loading = false;
      })

      .addCase(addParticipant.rejected, (state, action) => {
        state.error = action.payload;
      })

      /* ================= UPDATE ================= */
      .addCase(updateParticipant.fulfilled, (state, action) => {
        const updated = action.payload?.data;

        if (!updated || !updated.id) return;

        const index = state.participants.findIndex(
          (p) => p.id === updated.id
        );

        if (index !== -1) {
          state.participants[index] = {
            ...state.participants[index],
            ...updated,
          };
        }
      })

      .addCase(updateParticipant.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  setSelectedParticipant,
  clearSelectedParticipant,
} = tournamentParticipantsSlice.actions;

export default tournamentParticipantsSlice.reducer;